module.exports = __webpack_public_path__ + "img/what-is-an-api-thumbnail-tc.c9fb3dfe.jpg";